export function getInitials(name?: string | null): string | undefined {
  if (!name) return undefined;
  const parts = name.trim().split(/\s+/);
  if (!parts[0]?.[0]) return undefined;
  return parts.length === 1 ? parts[0][0] : `${parts[0][0]}${parts.at(-1)![0]}`;
}
